import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ModelTrainingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"model_training"}/>
}
